import SHEnumRadio from './src/radio.vue';

/* istanbul ignore next */
SHEnumRadio.install = function(Vue) {
  Vue.component('sh-enum-radio', SHEnumRadio);
};

export default SHEnumRadio;



// WEBPACK FOOTER //
// ./src/components/base/view/Enum/cmps/radio/index.js